
// import { fadeBanner, unfadeBanner } from './components.hero-banner';
import { getElements, getClasses } from './components.site-navigation';
import detectTouchscreen from '../utils/utils.detect-touchscreen';

var initialised = false,
	elements,
	classes;

const 	settings = {
			hoverDebounceTiming: 222
		};

export function navIsInitialised() {
	return initialised;
}

export function reset() {

	if ( navIsInitialised() ) {
		
		closeAllSubNavs();
		removeSubNavActiveClasses();
		removeSubSubNavActiveClasses();
		removeTouchEventListeners();
		initialised = false;
	}
}

function removeSubNavActiveClasses() {
	elements.siteNavItemWithChildren.forEach( item => {
		item.classList.remove('is-active');
	});
}

function removeSubSubNavActiveClasses() {
	elements.siteNavSubItemWithChildren.forEach( item => {
		item.classList.remove('is-active');
	});
}

function closeAllSubNavs() {
	elements.subNav.forEach( item => {
		// item.style.opacity = 0;
		// item.style.pointerEvents = 'none';

		item.setAttribute('style', '');
	});

	closeAllSubSubNavs();
	removeSubNavActiveClasses();
}

function closeAllSubSubNavs() {
	elements.subSubNav.forEach( item => {
		// item.style.opacity = 0;
		// item.style.pointerEvents = 'none';

		item.setAttribute('style', '');
	});
	
	removeSubSubNavActiveClasses();
}

function setAnywhereClickToCloseItems() {
	document.querySelector('.site-main').addEventListener('click', closeAllSubNavs);
}

function removeAnywhereClickToCloseItems() {
	document.querySelector('.site-main').removeEventListener('click', closeAllSubNavs);
}

function handleSiteNavItemWithChildrenClick(e) {
	e.preventDefault();
			
	let clickedElem = e.currentTarget;
	let subNav = clickedElem.nextElementSibling;

	if ( clickedElem.classList.contains('is-active') ) {
		window.location = clickedElem.getAttribute('href');
	} else {
		closeAllSubNavs();
		closeAllSubSubNavs();
		subNav.style.opacity = 1;
		subNav.style.pointerEvents = 'auto';
		clickedElem.classList.add('is-active');
	}
}

function addTouchEventListeners() {

	elements.siteNavItemWithChildren.forEach( item => {
		item.addEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	elements.siteNavSubItemWithChildren.forEach( item => {
		item.addEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	setAnywhereClickToCloseItems();
}

function removeTouchEventListeners() {

	elements.siteNavItemWithChildren.forEach( item => {
		item.removeEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	elements.siteNavSubItemWithChildren.forEach( item => {
		item.removeEventListener('click', handleSiteNavItemWithChildrenClick);
	});

	removeAnywhereClickToCloseItems();
}

export function init() {
	
	elements = getElements();
	classes = getClasses();

	if ( ! navIsInitialised() ) {

		if ( detectTouchscreen() ) {
			addTouchEventListeners();
			elements.siteNav.classList.add('is-touch');
		}

		closeAllSubNavs();
		removeSubNavActiveClasses();
		removeSubSubNavActiveClasses();

		initialised = true;
	}

	// document.querySelector('body').addEventListener('mouseover', () => {
	// 	console.log('switch to hover');
	// });

	// document.querySelector('body').addEventListener('touchstart', () => {
	// 	console.log('switch to touch');
	// });
}